import React from 'react'

import {useParams} from "react-router-dom";
import InactivityLogout from '../services/InactivityLogout';
import Header from '../components/Header'
import DigitalReportsLinkSection from '../components/digitalReportsLinkSection';


export default function DigitalReportsLink() {

    const {email} = useParams();
       
    return (
        <>
                <InactivityLogout>
                <Header searchterm={email} />
                <DigitalReportsLinkSection searchterm={email} />
                </InactivityLogout>
        </>
    );
}